import { updateDataLayer } from '@classic/Foundation/Analytics/Analytics'
import {
  getEnhancedBetslipSetting,
  isHapticFeedbackSettingEnabled,
} from '@core/Areas/Settings/Store/selectors'
import type { RootState } from '@core/Store'

export async function updateUserSettingsOnDataLayer(appState: RootState) {
  const isEnhancedBetslipEnabled = getEnhancedBetslipSetting(appState)
  const isHapticsEnabled = isHapticFeedbackSettingEnabled(appState)

  updateDataLayer({
    user: { isHapticsEnabled, isEnhancedBetslipEnabled },
  })
}
